import { RouteObject } from 'react-router-dom';
import { Settings } from './Settings';

export const settingsRoute: RouteObject = {
  path: 'settings',
  element: <Settings />,
};
